import { z } from 'zod';
import { ComponentType } from '@wix/dev-center-client';

export const backendWorkerComponentSchema = z
  .object({
    compType: z.literal(ComponentType.BACKEND_WORKER),
    compData: z
      .object({
        backendWorker: z.object({
          deploymentUrl: z.string().optional(),
        }),
      })
      .passthrough(),
  })
  .passthrough();
